var validDataset = ['scatter', 'bubble', 'errorScatter', 'selectScatter'];

var isDataset = function isDataset(a) {
  return 'dataset' === a.getType();
},
    isValidDataset = function isValidDataset(a) {
  return isDataset(a) && 0 <= validDataset.indexOf(a.getName());
};

function createLinear(a, b) {
  var c = +a.showregressionline || 0,
      d = isNaN(b.showregressionline) && c || +b.showregressionline;
  return d;
}

function createPolynomial(a, b) {
  var c = +a.showpolynomialregressionline || 0,
      d = isNaN(b.showpolynomialregressionline) && c || +b.showpolynomialregressionline;
  return d;
}

function isInArray(a, b) {
  return a = a.toLowerCase(), -1 < b.indexOf(a);
}

function hasRegressionLine(a, b) {
  return b.showregressionline || a.showregressionline || b.showpolynomialregressionline || a.showpolynomialregressionline;
}

export { createPolynomial, createLinear, isInArray, hasRegressionLine, isValidDataset };